import ChatDashboard from "@/components/ChatDashboard";

export default function InboxPage() {
  return (
    <div className="h-[calc(100vh-56px)] md:h-screen">
      <ChatDashboard />
    </div>
  );
}
